import {useState} from "react";
import HttpRequest from "../../services/Request";
import {ErrorNotification, SuccessNotification} from "../../services/Notification";
import HeaderMain from "../../components/layout/HeaderMain";
import Menu from "../../components/layout/Menu";

const Support = () => {
    const [message, setMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const submitMessage = async () => {
        if (message.trim() === '') {
            ErrorNotification('فیلد پیام خالی است', 'خطا')
            return
        }
        setLoading(true)
        await HttpRequest(`${process.env.REACT_APP_DOMAIN}/support`, () => {
            setMessage('');
            SuccessNotification('پیام شما ارسال شد.کارشناسان ما با شما ارتباط می گیرند', 'ارسال موفق')
        }, 'post', {message})
        setLoading(false)
    }
    return <div className='p-3'>
        <HeaderMain/>
        <Menu/>
        <div className='mt-3 shadow default-bg rounded-b-sm p-2 py-5 md:w-[95%] mx-auto'>
            <div>
        <textarea className={`w-full rounded p-2 `} rows={4} onChange={(e) => setMessage(e.target.value)}
                  placeholder={`درخواست یا پیشنهاد خود را درج کنید`} value={message}></textarea>
                <div className={`flex justify-end`}>
                    <button onClick={submitMessage} disabled={loading}
                            className={`text-white border border-white rounded bg-gray2 px-4 py-2`}>ارسال
                    </button>
                </div>
            </div>
        </div>
    </div>
}

export default Support